import TittleLink from './TittleLink';

export default TittleLink;
